import { environment } from '@environments/environment'
import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { PromoCode } from '@personas/interfaces/promo-code.interface'

/**
 * Handles all persona backend apis and operations
 */
@Injectable({
  providedIn: 'root'
})
export class PromoCodeService {
  /**
   * Creates the service and injects it's dependencies
   * @param http HttpClient
   */
  constructor(private http: HttpClient) {}
  /**
   * Creates a new promocode or all the promocodes if a list is provided
   * @param eventId
   * @param promoCodes
   * @returns Observable
   */
  createPromoCode(eventId: number, promoCodes: [PromoCode] | PromoCode) {
    return this.http.post(`${environment.planningApi}promoCodes`, {
      event_id: eventId,
      promoCodes: promoCodes[0] ? promoCodes : [promoCodes]
    })
  }
  /**
   * Get all promocodes created for the event
   * @param eventId
   * @returns
   */
  getPromoCodes(eventId: string) {
    return this.http.get(`${environment.planningApi}promoCodes`, {
      params: {
        event_id: eventId
      }
    })
  }
  /**
   * Update promocode
   * @param promoCodeId
   * @param props
   * @returns Observable
   */
  updatePromoCode(promoCodeId: number, props) {
    return this.http.patch(`${environment.planningApi}promoCodes`, {
      id: promoCodeId,
      ...props
    })
  }
  /**
   * Delete a promocode
   * @param promoCodeId
   * @returns Observable
   */
  deletePromoCode(promoCodeId) {
    return this.http.delete(`${environment.planningApi}promoCodes`, {
      params: {
        id: promoCodeId
      }
    })
  }
}
